var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-text-field',{ref:"input",attrs:{"value":_vm.value,"label":_vm.label,"placeholder":_vm.placeholder,"rules":_vm.internalRules,"required":_vm.required},on:{"input":_vm.handleInput},scopedSlots:_vm._u([{key:"prefix",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.selectedRegion.label)+"\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }